import { INote } from 'core/types';
import { mapQuotePartNotesToManagedNotes } from 'quotes/components';
import { QuoteEntityType, QuotePartNoteType } from 'quotes/enums';
import { mapCreateQuotePartNotesToQuotePartNotes } from 'quotes/mappers';
import { IQuotePartNote, IQuotePartNoteForm } from 'quotes/types';

interface IProps {
  notes: IQuotePartNote[];
  setNotes: (value: IQuotePartNote[]) => void;
  entityType?: QuoteEntityType;
  isAlternateVersionEnabled?: boolean;
}

export const useNotes = ({
  notes = [],
  setNotes,
  entityType,
  isAlternateVersionEnabled = false,
}: IProps) => {
  const hasUndiscardableNote = notes.some(
    (note) => note.type === QuotePartNoteType.UNDISCARDABLE_ITEM
  );

  const onAddNote = () => (data: IQuotePartNoteForm) => {
    const newQuotePartNotes = mapCreateQuotePartNotesToQuotePartNotes(data).filter(
      (note) => !hasUndiscardableNote || note.type !== QuotePartNoteType.UNDISCARDABLE_ITEM
    );

    const newManagedNotes = mapQuotePartNotesToManagedNotes(
      newQuotePartNotes,
      isAlternateVersionEnabled,
      entityType
    ).map((note) => ({
      ...note,
      id: note.id || Math.random(),
    }));

    setNotes([...notes, ...newManagedNotes]);
  };

  const onDeleteNote = async (deleteNote: Partial<INote>) => {
    const newManagedNotes = notes.filter((note) => note.id !== deleteNote.id);

    setNotes(newManagedNotes);
  };

  const onEditNote = (data: Partial<INote>) => {
    const newManagedNotes = notes.map((note) =>
      note.id === data.id ? { ...note, ...data } : note
    );

    setNotes(newManagedNotes);

    return Promise.resolve({ success: true });
  };

  return {
    onAddNote,
    onDeleteNote,
    onEditNote,
    hasUndiscardableNote,
  };
};
